var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87.2 87",
    style: {
      enableBackground: "new 0 0 87.2 87"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 43.6,
    y1: 8.8,
    x2: 43.6,
    y2: 78.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.9,
    y1: 43.5,
    x2: 78.3,
    y2: 43.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPlus);
export default __webpack_public_path__ + "static/media/menu-plus.ac4f758355333092ffb0c66b30f08491.svg";
export { ForwardRef as ReactComponent };